import { render, staticRenderFns } from "./input-form-penilaian-kplh.vue?vue&type=template&id=5ee45b1e&scoped=true&"
import script from "./input-form-penilaian-kplh.vue?vue&type=script&lang=js&"
export * from "./input-form-penilaian-kplh.vue?vue&type=script&lang=js&"
import style0 from "./input-form-penilaian-kplh.vue?vue&type=style&index=0&id=5ee45b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee45b1e",
  null
  
)

export default component.exports